import "./PaymentMethodsPopup.scss";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {IPaymentMethod} from "../../models/IPaymentMethod";
import {PaymentMethodService} from "../../services/paymentMethodService";

import StripeElements from "../StripeElements/StripeElements";

import mastercardIcon from "../../assets/images/icons/mastercard.svg";
import visaIcon from "../../assets/images/icons/visa.svg";

import moment from "moment/moment";
import {useElements, useStripe} from "@stripe/react-stripe-js";
import {PurchaseTypes} from "../../models/Payment";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import {ClassesService} from "../../services/classes.service";
import {PaymentService} from "../../services/payment.service";
import {openMessage} from "../../store/notification/notificationSlice";
import Spinner from "../Spiner/Spinner";
import CustomButton from "../UI/CustomButton/CustomButton";
import subscriptionIcon from "../../assets/images/icons/subscription.svg";
import ResultPaymentPopup from "../ResultPaymentPopup/ResultPaymentPopup";
import AddPaymentMethodPopup from "../AddPaymentMethodPopup/AddPaymentMethodPopup";

interface PaymentMethodsPopupProps {
    closePopupFn: () => void;
    functionOnContinue: () => void;
    purchasingType: PurchaseTypes;
    orderParams: any;
}

const PaymentMethodsPopup: React.FC<PaymentMethodsPopupProps> = ({
                                                                     closePopupFn,
                                                                     functionOnContinue,
                                                                     purchasingType,
                                                                     orderParams
                                                                 }) => {
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    const stripe = useStripe();
    const elements = useElements();

    const {gateway} = useAppSelector(state => state.stripeKeysSlice);
    const {profile} = useAppSelector(state => state.profileSlice);
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);

    const [paymentMethods, setPaymentMethods] = useState<{ loader: boolean, data: IPaymentMethod[] }>({
        loader: true,
        data: []
    });
    const [showAddPaymentPopup, setShowAddPaymentPopup] = useState<boolean>(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<IPaymentMethod | null | "subscription">(null);
    const [showResultPaymentPopup, setShowResultPaymentPopup] = useState<{
        show: boolean,
        type: "success" | "failed",
        title: string,
        description: string
    }>({show: false, title: "", description: "", type: "success"});
    const [isProcessing, setIsProcessing] = useState(false);
    const [isSubscriptionActive, setIsSubscriptionActive] = useState<boolean>(false);

    const subscriptionItemVisible = purchasingType === "appointment" && isSubscriptionActive;

    useEffect(() => {
        if (profile) {
            getPaymentMethods(profile.customerId);
        }
    }, [profile]);

    useEffect(() => {
        // if (!stripe || !elements) return;
        //
        // const paymentRequest = stripe.paymentRequest({
        //     currency: gymSettings?.defaultCurrency ? gymSettings?.defaultCurrency : 'eur',
        //     country: "GR",
        //     requestPayerName: true,
        //     requestPayerEmail: true,
        //     total: {
        //         label: "Payment",
        //         amount: Number(10) * 100
        //     }
        // });
        //
        // const prButton = elements.create("paymentRequestButton", {
        //     paymentRequest,
        //     style: {
        //         paymentRequestButton: {
        //             theme: "light",
        //             height: "66px"
        //         },
        //     }
        // });
        //
        // paymentRequest.canMakePayment().then(res => {
        //     if (res) {
        //         prButton.mount("#payment-request-button");
        //     } else {
        //         // @ts-ignore
        //         document.getElementById("payment-request-button").style.display = "none";
        //     }
        // });
        //
        // paymentRequest.on("paymentmethod", (event) => {
        //     payWithGoogle(stripe, prButton, event);
        // });

    }, [stripe, elements]);

    useEffect(() => {
        if (purchasingType === PurchaseTypes.Appointment) {
            getSubscriptionForAppointment(orderParams.courseId, orderParams.attendanceDate);
        }
    }, []);

    // const payWithGoogle = (stripe: Stripe, prButton: StripePaymentRequestButtonElement, ev: PaymentRequestPaymentMethodEvent, model?: any) => {
    //     console.log("inside pay with google");
    // }

    const getSubscriptionForAppointment = async (classId: number, attendanceDate: string) => {
        if (!profile) return;
        const model = {
            courseId: classId,
            customerId: profile.id
        }
        try {
            const response = await ClassesService.getSubscriptionForAppointment(model);
            if (response.data) {
                const subscription = response.data;
                let plusFreezeDays = 0;
                if (subscription.freezeStatus === 0 && moment(subscription.freezeStartsAt).isValid()) {
                    plusFreezeDays = moment().diff(moment(subscription.freezeStartsAt), "days");
                }
                const isActive: boolean = moment(attendanceDate).isBefore(moment(subscription.startsAt).add(subscription.days + plusFreezeDays, "days"));
                setIsSubscriptionActive(subscription.package.hasAppointments && isActive);
            }

        } catch (e) {
        }


    }

    const getPaymentMethods = async (customerId: number) => {
        setPaymentMethods({loader: true, data: []});
        try {
            const response = await PaymentMethodService.getPaymentMethodsByCustomerId(customerId);
            if (!selectedPaymentMethod) {
                const defaultPaymentMethod = response.data.find(el => el.isDefault);
                setSelectedPaymentMethod(defaultPaymentMethod || null);
            }
            setPaymentMethods({loader: false, data: response.data});
        } catch (e) {
            setPaymentMethods({loader: false, data: []});
        }
    }

    const hideAddPaymentMethodPopup = () => {
        setShowAddPaymentPopup(false);
        if (profile) {
            getPaymentMethods(profile.customerId);
        }
    }

    const hidePaymentResultPopup = () => {
        functionOnContinue();
        setIsProcessing(false);
        setShowResultPaymentPopup({show: false, title: "", description: "", type: "success"});
    }

    const buySubscription = () => {
        setIsProcessing(true);
        const model = {
            ...orderParams,
            paymentMethodId: typeof selectedPaymentMethod !== "string" && selectedPaymentMethod?.id,
            isGooglePay: false
        }

        PaymentService.buySubscription(model).then(payIntentResponse => {
            if (payIntentResponse.data.data && !payIntentResponse.data.data.paymentSuccess) {
                if (payIntentResponse.data.error) {
                    dispatch(openMessage({
                        type: "error",
                        title: t(payIntentResponse.data.error.message)
                    }));
                    setShowResultPaymentPopup({
                        show: true,
                        type: "failed",
                        title: t("PaymentFailed"),
                        description: t("YourPaymentFailedPleaseTryAgain")
                    })
                    return;
                }
                const action = payIntentResponse.data.data.nextAction;
                if (action && action.type === "redirect_to_url") {
                    window.location = action.redirect_to_url.url;
                    return;
                }
                return PaymentService.pay(payIntentResponse.data.data).then((payResponse: any) => {
                    if (payResponse.data.error) {
                        setShowResultPaymentPopup({
                            show: true,
                            type: "failed",
                            title: t("PaymentFailed"),
                            description: t("YourPaymentFailedPleaseTryAgain")
                        })
                        return;
                    } else {
                        if (payResponse.data.success && (payResponse.data.data.status === "succeeded" || payResponse.data.data.status === "requires_capture")) {
                            setShowResultPaymentPopup({
                                show: true,
                                type: "success",
                                title: t("PaymentDoneSuccessfully"),
                                description: t("YourPaymentIsDoneSuccessfullyCheckYourEmailForConfirmation")
                            })
                            return;
                        } else {
                            setShowResultPaymentPopup({
                                show: true,
                                type: "failed",
                                title: t("PaymentFailed"),
                                description: t("YourPaymentFailedPleaseTryAgain")
                            })
                            return;
                        }
                    }
                }).catch(() => {
                    setShowResultPaymentPopup({
                        show: true,
                        type: "failed",
                        title: t("PaymentFailed"),
                        description: t("YourPaymentFailedPleaseTryAgain")
                    })
                    return;
                });
            } else {
                setShowResultPaymentPopup({
                    show: true,
                    type: "success",
                    title: t("PaymentDoneSuccessfully"),
                    description: t("YourPaymentIsDoneSuccessfullyCheckYourEmailForConfirmation")
                })
            }
        })

    }

    const buyAppointments = () => {
        setIsProcessing(true);
        const model = {
            paymentMethodId: typeof selectedPaymentMethod !== "string" && selectedPaymentMethod?.id,
            courseId: orderParams.courseId,
            customerId: orderParams.courseId,
            customerStripeId: gateway.customerId,
            instructorId: orderParams.instructorId,
            attendanceDate: orderParams.attendanceDate,
            loyaltyExchangeId: orderParams.loyaltyExchangeId,
            isCreateInvoice: true,
            comment: "",
            remark: ""
        }
        let queryParam = `?api_version=2022-11-15&createIntent=1&paymentMethodId=${typeof selectedPaymentMethod !== "string" && selectedPaymentMethod?.id}&returnUrl=${orderParams.returnUrl}`;
        if (orderParams.couponCode) {
            queryParam += `&couponCode=${orderParams.couponCode}`;
        }

        PaymentService.buyAppointments(model, queryParam).then(payIntentResponse => {
            if (payIntentResponse.data.error) {
                dispatch(openMessage({type: "error", title: t(payIntentResponse.data.error.message)}));
                setShowResultPaymentPopup({
                    show: true,
                    type: "failed",
                    title: t("PaymentFailed"),
                    description: t("YourPaymentFailedPleaseTryAgain")
                })
                return;
            }
            const action = payIntentResponse.data.data.nextAction;
            if (action && action.type === "redirect_to_url") {
                window.location = action.redirect_to_url.url;
                return;
            }
            return PaymentService.pay(payIntentResponse.data.data).then((payResponse: any) => {
                if (payResponse.data.error) {
                    setShowResultPaymentPopup({
                        show: true,
                        type: "failed",
                        title: t("PaymentFailed"),
                        description: t("YourPaymentFailedPleaseTryAgain")
                    })
                    return;
                } else {
                    if (payResponse.data.success && (payResponse.data.data.status === "succeeded" || payResponse.data.data.status === "requires_capture")) {
                        setShowResultPaymentPopup({
                            show: true,
                            type: "success",
                            title: t("PaymentDoneSuccessfully"),
                            description: t("YourPaymentIsDoneSuccessfullyCheckYourEmailForConfirmation")
                        })
                        return;
                    } else {
                        setShowResultPaymentPopup({
                            show: true,
                            type: "failed",
                            title: t("PaymentFailed"),
                            description: t("YourPaymentFailedPleaseTryAgain")
                        })
                        return;
                    }
                }
            }).catch((err) => {
                setShowResultPaymentPopup({
                    show: true,
                    type: "failed",
                    title: t("PaymentFailed"),
                    description: t("YourPaymentFailedPleaseTryAgain")
                })
                if (err.error && err.status === 400 && err.error === "APPOINTMENT_CLOSED") {
                    dispatch(openMessage({type: "error", title: t("AppointmentClosed")}))
                }
                return;
            });
        })

    }

    const buyAppointmentsWithSubscription = async () => {
        setIsProcessing(true);
        const model = {
            courseId: orderParams.courseId,
            attendanceDate: orderParams.attendanceDate,
            customerId: orderParams.customerId,
            instructorId: orderParams.instructorId,
            comment: ""
        }
        try {
            const response = await PaymentService.buyAppointmentBySubscription(model);
            if (response.data && response.data.appointmentId) {
                setShowResultPaymentPopup({
                    show: true,
                    title: t("PaymentDoneSuccessfully"),
                    description: t("AppointmentCreatedSuccessfully"),
                    type: "success"
                })
            } else {
                setShowResultPaymentPopup({
                    show: true,
                    title: t("PaymentFailed"),
                    description: t("FailedToMakeAnAppointment"),
                    type: "failed"
                })
            }
        } catch (e) {
            setShowResultPaymentPopup({
                show: true,
                title: t("PaymentFailed"),
                description: t("FailedToMakeAnAppointment"),
                type: "failed"
            })
        }
    }

    const buyDropIn = () => {
        setIsProcessing(true);
        const model = {
            friends: orderParams.friends
        }
        const queryParams = `?classEventId=${orderParams.classEventId}&returnUrl=${orderParams.returnUrl}`;
        PaymentService.buyDropIn(model, queryParams).then(orderDetailsResponse => {
            if (orderDetailsResponse.data.error) {
                dispatch(openMessage({type: "error", title: t(orderDetailsResponse.data.error.message)}));
                setShowResultPaymentPopup({
                    show: true,
                    type: "failed",
                    title: t("PaymentFailed"),
                    description: t("YourPaymentFailedPleaseTryAgain")
                })
                return;
            } else {
                let queryParamsForBuying = `?classEventId=${orderParams.classEventId}&returnUrl=${orderParams.returnUrl}&createIntent=1&paymentMethodId=${typeof selectedPaymentMethod !== "string" && selectedPaymentMethod?.id}&api_version=2022-11-15&customerId=${gateway.customerId}`;
                if (orderParams.couponCode) {
                    queryParamsForBuying += `&couponCode=${orderParams.couponCode}`;
                }
                if (orderParams.loyaltyExchangeId) {
                    queryParamsForBuying += `&loyaltyExchangeId=${orderParams.loyaltyExchangeId}`;
                }
                PaymentService.buyDropIn(model, queryParamsForBuying).then(payIntentResponse => {
                    if (payIntentResponse.data.error) {
                        dispatch(openMessage({
                            type: "error",
                            title: t(payIntentResponse.data.error.message)
                        }));
                        setShowResultPaymentPopup({
                            show: true,
                            type: "failed",
                            title: t("PaymentFailed"),
                            description: t("YourPaymentFailedPleaseTryAgain")
                        })
                        return
                    }
                    const action = payIntentResponse.data.data.nextAction;
                    if (action && action.type === "redirect_to_url") {
                        window.location = action.redirect_to_url.url;
                        return;
                    }
                    return PaymentService.pay(payIntentResponse.data.data).then((payResponse: any) => {
                        if (payResponse.data.error) {
                            setShowResultPaymentPopup({
                                show: true,
                                type: "failed",
                                title: t("PaymentFailed"),
                                description: t("YourPaymentFailedPleaseTryAgain")
                            })
                            return;
                        } else {
                            if (payResponse.data.success && (payResponse.data.data.status === "succeeded" || payResponse.data.data.status === "requires_capture")) {
                                setShowResultPaymentPopup({
                                    show: true,
                                    type: "success",
                                    title: t("PaymentDoneSuccessfully"),
                                    description: t("YourPaymentIsDoneSuccessfullyCheckYourEmailForConfirmation")
                                })
                                return;
                            } else {
                                setShowResultPaymentPopup({
                                    show: true,
                                    type: "failed",
                                    title: t("PaymentFailed"),
                                    description: t("YourPaymentFailedPleaseTryAgain")
                                })
                                return;
                            }
                        }
                    }).catch((err) => {
                        setShowResultPaymentPopup({
                            show: true,
                            type: "failed",
                            title: t("PaymentFailed"),
                            description: t("YourPaymentFailedPleaseTryAgain")
                        })
                        return;
                    });
                })
            }
        })

    }

    const buyVenues = () => {
        setIsProcessing(true);
        const model = {
            paymentMethodId: typeof selectedPaymentMethod !== "string" && selectedPaymentMethod?.id,
            api_version: "2022-11-15",
            customerId: orderParams.customerId,
            startDate: orderParams.startDate,
            endDate: orderParams.endDate,
            trainingRoomIds: orderParams.trainingRoomIds,
            returnUrl: orderParams.returnUrl,
            customerStripeId: gateway.customerId
        }

        PaymentService.buyVenues(model).then(paymentIntentResponse => {
            if (!paymentIntentResponse.data.success) {
                setShowResultPaymentPopup({
                    show: true,
                    type: "failed",
                    title: t("PaymentFailed"),
                    description: t("YourPaymentFailedPleaseTryAgain")
                })
                return;
            }

            const action = paymentIntentResponse.data.data.nextAction;
            if (action && action.type === "redirect_to_url") {
                window.location = action.redirect_to_url.url;
                return;
            }
            return PaymentService.pay(paymentIntentResponse.data.data).then((payResponse: any) => {
                if (payResponse.data.error) {
                    setShowResultPaymentPopup({
                        show: true,
                        type: "failed",
                        title: t("PaymentFailed"),
                        description: t("YourPaymentFailedPleaseTryAgain")
                    })
                    return;
                } else {
                    if (payResponse.data.success && (payResponse.data.data.status === "succeeded" || payResponse.data.data.status === "requires_capture")) {
                        setShowResultPaymentPopup({
                            show: true,
                            type: "success",
                            title: t("PaymentDoneSuccessfully"),
                            description: t("YourPaymentIsDoneSuccessfullyCheckYourEmailForConfirmation")
                        })
                        return;
                    } else {
                        setShowResultPaymentPopup({
                            show: true,
                            type: "failed",
                            title: t("PaymentFailed"),
                            description: t("YourPaymentFailedPleaseTryAgain")
                        })
                        return;
                    }
                }
            }).catch((err) => {
                setShowResultPaymentPopup({
                    show: true,
                    type: "failed",
                    title: t("PaymentFailed"),
                    description: t("YourPaymentFailedPleaseTryAgain")
                })
                return;
            });

        })


    }

    const clickOnContinue = () => {
        if (purchasingType === PurchaseTypes.Subscription) {
            buySubscription();
        } else if (purchasingType === PurchaseTypes.Appointment) {
            if (selectedPaymentMethod === "subscription") {
                buyAppointmentsWithSubscription();
            } else {
                buyAppointments();
            }
        } else if (purchasingType === PurchaseTypes.Dropin) {
            buyDropIn()
        } else if (purchasingType === PurchaseTypes.Venues) {
            buyVenues();
        }
    }

    const renderPaymentMethodItem = (paymentMethod: IPaymentMethod) => {

        const clickOnPaymentMethodItem = () => {
            setSelectedPaymentMethod(paymentMethod)
        }

        const brandIcon = paymentMethod.brand === "visa" ? visaIcon : mastercardIcon
        const expMonth = paymentMethod.expMonth.toString().length === 1 ? "0" + paymentMethod.expMonth.toString() : paymentMethod.expMonth.toString();
        const expYear = paymentMethod.expYear.toString().slice(2, 4)

        return (
            <div key={paymentMethod.id} className={"item"} onClick={clickOnPaymentMethodItem}>
                <div className={"left-side"}>
                    <img src={brandIcon} alt={paymentMethod.brand}/>
                    <div className={"info"}>
                        <h4>{paymentMethod.brand.toUpperCase()} **** {paymentMethod.last4}</h4>
                        {
                            paymentMethod.nameOnCard && (
                                <p className={"alias"}>{paymentMethod.nameOnCard}</p>
                            )
                        }
                        <p className={"date"}>EXP. {expMonth}/{expYear}</p>
                    </div>
                </div>
                <div className={"right-side"}>
                    {
                        paymentMethod.isDefault && (
                            <span className={"default"}>{t("Default")}</span>
                        )
                    }
                    <div
                        className={`circle ${typeof selectedPaymentMethod !== "string" && paymentMethod.id === selectedPaymentMethod?.id && "active"}`}></div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className={"payment-methods-popup-container"}>
                <div className={"popup"}>
                    <div className={"top"}>
                        <h3 className={"title"}>{t("SelectPaymentMethod")}</h3>
                    </div>
                    <div className={"content"}>
                        {
                            paymentMethods.loader ? (
                                <div className={"loader-wrapper"}>
                                    <Spinner/>
                                </div>
                            ) : (
                                <div className={"wrapper custom-scroll"}>
                                    {
                                        subscriptionItemVisible && (
                                            <div onClick={() => setSelectedPaymentMethod("subscription")}
                                                 className={"item subscription"}>
                                                <div className={"left-side"}>
                                                    <img src={subscriptionIcon} alt={"subscription"}/>
                                                    <h3>{t("Subscription")}</h3>
                                                </div>
                                                <div className={"right-side"}>
                                                    <div
                                                        className={`circle ${selectedPaymentMethod === "subscription" && "active"}`}></div>
                                                </div>
                                            </div>

                                        )
                                    }
                                    {/*<div className={"card-inside"}>*/}
                                    {/*    <div id="payment-request-button" className={"google-pay-btn"}></div>*/}
                                    {/*</div>*/}
                                    {paymentMethods.data.map(el => {
                                        return renderPaymentMethodItem(el);
                                    })}
                                </div>
                            )
                        }
                        <button className={"add-btn"} onClick={() => setShowAddPaymentPopup(true)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.6667 22.6667C10.6667 23.0203 10.8071 23.3594 11.0572 23.6095C11.3072 23.8595 11.6464 24 12 24C12.3536 24 12.6928 23.8595 12.9428 23.6095C13.1929 23.3594 13.3333 23.0203 13.3333 22.6667V13.3333H22.6667C23.0203 13.3333 23.3594 13.1929 23.6095 12.9428C23.8595 12.6928 24 12.3536 24 12C24 11.6464 23.8595 11.3072 23.6095 11.0572C23.3594 10.8071 23.0203 10.6667 22.6667 10.6667H13.3333V1.33333C13.3333 0.979711 13.1929 0.640573 12.9428 0.390524C12.6928 0.140476 12.3536 0 12 0C11.6464 0 11.3072 0.140476 11.0572 0.390524C10.8071 0.640573 10.6667 0.979711 10.6667 1.33333V10.6667H1.33333C0.979711 10.6667 0.640573 10.8071 0.390524 11.0572C0.140476 11.3072 0 11.6464 0 12C0 12.3536 0.140476 12.6928 0.390524 12.9428C0.640573 13.1929 0.979711 13.3333 1.33333 13.3333H10.6667V22.6667Z"
                                    fill="#4E72E6"/>
                            </svg>
                            {t("AddNewCard")}
                        </button>
                    </div>
                    <div className={"bottom"}>
                        <CustomButton
                            text={t("Cancel")}
                            type={"button"}
                            typeStyle={"outline"}
                            blueForOutline={true}
                            borderRadius={false}
                            style={{borderColor: "#FFF"}}
                            functionOnClick={closePopupFn}
                        />
                        <CustomButton
                            text={t("Continue")}
                            type={"button"}
                            typeStyle={"fill"}
                            style={{borderRadius: "5px"}}
                            borderRadius={false}
                            disabled={!selectedPaymentMethod || isProcessing}
                            functionOnClick={clickOnContinue}
                        />
                    </div>
                </div>
            </div>
            {
                showAddPaymentPopup && (
                    <StripeElements>
                        <AddPaymentMethodPopup
                            closePopupFn={hideAddPaymentMethodPopup}
                            getPaymentsMethodFn={getPaymentMethods}
                        />
                    </StripeElements>
                )
            }
            {
                showResultPaymentPopup.show && (
                    <ResultPaymentPopup
                        type={showResultPaymentPopup.type}
                        title={showResultPaymentPopup.title}
                        description={showResultPaymentPopup.description}
                        clickOnBack={hidePaymentResultPopup}
                    />
                )
            }
        </>
    )
}

export default PaymentMethodsPopup;